export async function getFile(url: string, filename?: string, includeType?: boolean): Promise<File | null> {
	try {
		const parsedUrl = new URL(url, 'https://dummy.com'); // we just need a base URL to retrieve the pathname
		const result = await fetch(url);
		const blob = await result.blob();

		const derivedFilename =
			filename || decodeURIComponent(parsedUrl.pathname.split('/').pop() || '').split('?')[0] || 'file';

		if (includeType) {
			return new File([blob], derivedFilename, { type: blob.type });
		}

		return new File([blob], derivedFilename);
	} catch (e) {
		return null;
	}
}
